<template>
    <layout title="Accounting Emails">
        <settings-layout>
            <form @submit.prevent="submit">
                <div class="px-8">
                    <div class="flex flex-col">
                        <div class="font-semibold text-lg">
                            Accounting Email List
                        </div>
                        <p class="text-sm text-gray-500">Please add a comma separated list of all emails that should receive accounting related emails.</p>
                    </div>
                    <div class="my-4">
                        <textarea v-model="newEmails" ref="emails" id="emails" name="emails" rows="10" class="mt-2 shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 font-mono sm:text-sm border-gray-300 rounded-md"></textarea>
                    </div>
                    <div class="flex justify-end">
                        <loading-button :loading="saving"  type="submit" class="">
                            Save
                        </loading-button>
                    </div>
                </div>
            </form>
        </settings-layout>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import NewsList from '@/Components/News/NewsList'
import SettingsLayout from "./SettingsLayout";
import LoadingButton from "@/Shared/LoadingButton";

export default {
    components: {SettingsLayout, NewsList, Layout, LoadingButton },
    props: {
        emails: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            newEmails: this.emails.emails ?? '',
            saving: false,
        }
    },
    metaInfo() {
        return {
            title: `Settings`,
        }
    },
    methods: {
        submit() {
            this.$inertia.post(this.route('settings.accounting-emails.store'), { emails: this.newEmails }, {
                onStart: () => this.saving = true,
                onFinish: () => this.saving = false,
            })
        }
    }
}
</script>
